import despatchList from "dummydata/despatchList";
import { DESPATCH_TOTAL } from "redux/actionTypes/actionTypes";
import { DELETE_DESPATCH } from "redux/actionTypes/actionTypes";
import { ADD_DESPATCH } from "redux/actionTypes/actionTypes";

const initialState = {
  despatchList: [],
  despatchTotal: 0,
};

const despatchReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_DESPATCH:
      return {
        ...state,
        despatchList: action.payload,
      };
      break;
    case DELETE_DESPATCH:
      return {
        ...state,
        despatchList: state.despatchList.filter(
          (item) => !action.payload.includes(item.key)
        ),
      };
      break;
    case DESPATCH_TOTAL:
      return {
        ...state,
        despatchTotal: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};
export default despatchReducer;
